import { Navigate } from "react-router-dom";

export function FirmwareNewPage(): JSX.Element {
  return <Navigate to="/engineering/firmware?new=1" replace />;
}
